// @flow
import React from 'react';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import BulletList from 'app/components/BulletList';
import styles from './SideNews.styles';
import api from 'utils/API';
import sidebarToggle from 'app/redux/actions/sidebarToggle';

class SideNews extends React.Component<Props> {
  unmounted = false;

  constructor(props) {
    super(props);

    this.state = {
      list: []
    };
  }

  closeSidebar = () => {
    this.props.dispatch(sidebarToggle('close'));
  }

  componentDidMount() {
    api.post('/pages/lastnews')
    .then(response => {
      if (this.unmounted) {
        return;
      }
      
      const list = response.data.list || [];
      this.setState({list});
    });
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    const {classes} = this.props;
    
    return (
      <React.Fragment>
        <div className={classes.wrapper}>
          <div className={classes.fixedWrapper}>
            <div>
              <span className={classes.closeButton} onClick={this.closeSidebar}>x</span>
            </div>
            <div className={classes.container}>
              <BulletList list={this.state.list} />
            </div>
          </div>
        </div>
        <div
          className={classNames(classes.pageOverlay, {[classes.isOpen]: this.props.isOpen})}
          onClick={this.closeSidebar}
        >
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    isOpen: state.sidebarToggle === 'open'
  })
};

const Component = connect(mapStateToProps)(withStyles(styles)(SideNews));
export {Component as SideNews};
export default Component;